import {
  $http,
  Get,
  Post,
  Put,
  Patch,
  Delete,
  RequestUse
} from 'skytech-request'
import { init as domainInit, getRequestUse, getDomain } from 'sky-domain'

domainInit("sso", process.env.NODE_ENV)
window.getRequestUse = getRequestUse
window.getDomain = getDomain

RequestUse(window.getRequestUse);
const addToken = (config) => {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${localStorage.getItem("Authorization")}`
  }
  return config;
}
RequestUse(addToken);

export {
  Get,
  Post,
  Put,
  Patch,
  Delete
}


// WEBPACK FOOTER //
// ./src/services/base/baseAjax.js